
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bring-your-own-team",
      function () {
        return require("private-next-pages/bring-your-own-team.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bring-your-own-team"])
      });
    }
  